// extracted by mini-css-extract-plugin
export default {"rootEmergency":"emergencyContact_rootEmergency__vKg2U","konekCard":"emergencyContact_konekCard__+757v","rootPopBody":"emergencyContact_rootPopBody__kW1cp"};